import { isNaN } from 'lodash';

export function toBoolean(boolean) {
  switch (typeof boolean) {
    case 'boolean':
      return boolean;
    case 'string':
      switch (boolean.toLowerCase().trim()) {
        case 'true': case 'yes': case '1': return true;
        case 'false': case 'no': case '0': case null: return false;
        default: return Boolean(boolean);
      }
    default: return Boolean(boolean);
  }
}

export function toInteger(string, base = 10) {
  const integer = parseInt(string, base);
  return (isNaN(integer)) ? null : integer;
}

export default {
  toBoolean,
  toInteger,
};
